import React, { useState } from "react";
import PageLayout from "../components/PageLayout";
import styles from "../styles/FileUpload.module.css";

const FileUpload = () => {
  const [singleFileName, setSingleFileName] = useState("");
  const [multiFileCount, setMultiFileCount] = useState(0);

  return (
    <PageLayout
      title="📁 FILE UPLOAD INTERACTIONS"
      sidebarContent={
        <>
          <p>Practice file upload automation using Playwright:</p>
          <ul>
            <li>Single file upload</li>
            <li>Multiple file upload</li>
            <li>Button for Upload</li>
          </ul>
        </>
      }
    >
      <div className={styles.row}>

        {/* Single File */}
        <div className={styles.inputGroup}>
          <label htmlFor="singleFile"><b>SINGLE FILE UPLOAD</b></label>
          <input
            id="singleFile-Upload"
            type="file"
            name="singleFile"
            onChange={(e) =>
              setSingleFileName(e.target.files[0]?.name || "")
            }
          />
          {singleFileName && (
            <span className={styles.info}>{singleFileName}</span>
          )}
        </div>

        {/* Multiple Files */}
        <div className={styles.inputGroup}>
          <label htmlFor="multiFile"><b>MULTIPLE FILE UPLOAD</b></label>
          <input
            id="multiFile-upload"
            type="file"
            name="multiFile"
            multiple
            onChange={(e) => setMultiFileCount(e.target.files.length)}
          />
          {multiFileCount > 0 && (
            <span className={styles.info}>
              {multiFileCount} files selected
            </span>
          )}
        </div>

        {/* Button */}
        <div className={styles.inputGroup}>
          <label><b>UPLOAD BUTTON</b></label>
          <button
            id="upload-btn"
            type="submit"
            value="Upload"
            className={styles.button}
            onClick={() => alert("Upload button clicked")}
          >
            Upload File
          </button>
        </div>

      </div>
    </PageLayout>
  );
};

export default FileUpload;
